import { useSelectedTerminalContext } from '@components/Admin/Location/Cards/components/CreateCard/TerminalSelection/TerminalSelectionContext'
import { Horizontal, Texto, Vertical } from '@gravitate-js/excalibrr'
import { Checkbox } from 'antd'
import React, { useMemo } from 'react'

export const SupplyGrouping = ({ node, value }) => {
  const { selectedTerminals } = useSelectedTerminalContext()

  const checked = useMemo(() => {
    if (!selectedTerminals?.length) return false
    const hasUncheckedChild = node.childrenAfterFilter.some((node) => !node.isSelected())
    return !hasUncheckedChild
  }, [selectedTerminals])

  const handleSelect = (e) => {
    const isSelected = e.target.checked
    node.childrenAfterFilter.forEach((node) => {
      node.setSelected(isSelected)
    })
  }

  return (
    <Horizontal className={'p-2'}>
      <Checkbox onChange={handleSelect} className={'mr-2'} checked={checked} />
      <Vertical>
        <Texto>{value}</Texto>
      </Vertical>
    </Horizontal>
  )
}
